import { CRMFieldAPIPathGenerator, FieldDocument, EntityType, FieldGroupDocument, APIQueryParamFragments, FieldValidationError, APIResponse } from "server-model";
import { AppServerConnector } from "./app-server.connector";
import { CRMFieldConnector } from "../data-connectors";

export class AppServerCRMFieldConnector extends AppServerConnector implements CRMFieldConnector {
    async getField(fieldName: string, organisationId: string, entityType: EntityType): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMFieldAPIPathGenerator.details(entityType, fieldName),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Field not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async listFields(organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMFieldAPIPathGenerator.list(),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Field not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getAllFieldsSpecificEntity(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMFieldAPIPathGenerator.listSpecificEntity(entityType),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Field not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getAllFieldsSpecificGroup(organisationId: string, entityType: EntityType, groupName: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMFieldAPIPathGenerator.listSpecificGroup(entityType, groupName),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Field not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async createField(fieldDocument: FieldDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMFieldAPIPathGenerator.create(),
                { fieldDocument: this.toPlain(fieldDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create field")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateField(fieldName: string, organisationId: string, entityType: EntityType, fieldDocument: FieldDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                CRMFieldAPIPathGenerator.update(entityType, fieldName),
                { fieldDocument: this.toPlain(fieldDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update field")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteField(fieldName: string, organisationId: string, entityType: EntityType): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                CRMFieldAPIPathGenerator.delete(entityType, fieldName),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete field")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }







    async getFieldGroup(groupName: string, organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMFieldAPIPathGenerator.detailsGroup(groupName),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Field group not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async listFieldGroups(organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMFieldAPIPathGenerator.listGroup(),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Field group not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async createFieldGroup(fieldGroupDocument: FieldGroupDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMFieldAPIPathGenerator.createGroup(),
                { fieldGroupDocument: this.toPlain(fieldGroupDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create field group")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateFieldGroup(groupName: string, organisationId: string, fieldGroupDocument: FieldGroupDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.put(
                CRMFieldAPIPathGenerator.updateGroup(groupName),
                { fieldGroupDocument: this.toPlain(fieldGroupDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update field group")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteFieldGroup(groupName: string, organisationId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                CRMFieldAPIPathGenerator.deleteGroup(groupName),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete field group")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async validateField(organisationId: string, entityType: EntityType, fields: { name: string; value: any }[]): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMFieldAPIPathGenerator.validateField(entityType),
                {fields: this.toPlain(fields)},
                this.getHeaders(),
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to validate field")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}